import {useTrans} from '@common/i18n/use-trans';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {useMutation} from '@tanstack/react-query';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {apiClient, queryClient} from '@common/http/query-client';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {UseFormReturn} from 'react-hook-form';
import { Prompt } from '@app_modules/chats/prompt';
import { useParams } from 'react-router-dom';
import { BackendResponse } from '@common/http/backend-response/backend-response';
import { UwDemo } from '@app_modules/chats/uw';


interface Response extends BackendResponse {
  prompt: Prompt;
}

export interface DemoUwPayload extends UwDemo {
 report_id: string;
}

export function useDemoUw(form: UseFormReturn<DemoUwPayload>) {
  return useMutation({
    mutationFn: (payload: DemoUwPayload) => createUwAction(payload),
    onSuccess: response => {
      
      // toast(trans(message('Chat updated')));
      // queryClient.invalidateQueries({
      //   queryKey: [Endpoint(response. chat.id)],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: DatatableDataQueryKey('chats'),
      // });
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function createUwAction(payload: DemoUwPayload) {
  return apiClient.post<Response>('demo-uw', FilePayloadToFormData(payload), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(r => r.data);
}


export function FilePayloadToFormData(
payload: Partial<DemoUwPayload>,
) {
  const formData = new FormData();

  if (payload.income_type != undefined) {
    formData.append("income_type", payload.income_type);
  }

  if (payload.report_id != undefined) {
    formData.append("report_id", payload.report_id);
  }

  if (payload.sources != undefined) {
    payload.sources.forEach((source) => {
      formData.append("sources[]", source);
    });
  }

  if (payload.files) {
    payload.files.forEach((file) => {
      formData.append("files[]", file);
    });
  }

  return formData;
}